export const generateUID = (): string =>
	!!window?.crypto?.randomUUID
		? window.crypto.randomUUID()
		: window.btoa(Date.now().toString() + Math.random().toString())
